const escolas_ensinos_fases_turnos_ministrados = {
  path: "/relatorio-de-apoio-gerencial-escolas-ensinos-fases-turnos-ministrados",
  redirect:
    "/relatorio-de-apoio-gerencial-escolas-ensinos-fases-turnos-ministrados",
  meta: {
    breadCrumb:
      "Gerenciamento de Matrícula - Apoio Gerencial de Planejamento da Matrícula",
  },
  children: [
    {
      path: "/relatorio-de-apoio-gerencial-escolas-ensinos-fases-turnos-ministrados",
      name: "relatorio-de-apoio-gerencial-escolas-ensinos-fases-turnos-ministrados",
      meta: {
        allowedPermissions: ["estrutura_turma_listar_ensino_fase_turno"],
      },
      component: () =>
        import(
          "@/views/EscolasEnsinosFasesTurnoMinistrados/EscolasEnsinosFasesTurnoMinistrados.vue"
        ),
    },
  ],
};

export { escolas_ensinos_fases_turnos_ministrados };
